"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = exports.Services = void 0;
const initializeLogging_1 = require("../utils/initializeLogging");
const utils_1 = require("../utils");
const api_1 = require("../api");
const fillInConfigDefaults_1 = require("../utils/fillInConfigDefaults");
var Services;
(function (Services) {
    Services["FETCH_CONFIG"] = "@service/FETCH_CONFIG";
    Services["FETCH_TYPEAHEAD_SUGGESTIONS"] = "@service/FETCH_TYPEAHEAD_SUGGESTIONS";
    Services["INITIALIZE_LOGGING"] = "@service/INITIALIZE_LOGGING";
    Services["FILL_IN_CONFIG_DEFAULTS"] = "@service/FILL_IN_CONFIG_DEFAULTS";
})(Services = exports.Services || (exports.Services = {}));
exports.services = {
    [Services.FETCH_CONFIG]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { pmcUrl, id } = context;
        const response = yield (0, api_1.fetchConfig)(id, pmcUrl);
        return response.result;
    }),
    [Services.FETCH_TYPEAHEAD_SUGGESTIONS]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { config, typeaheadTerms, useV8, pmcUrl, productName } = context;
        if (config && typeaheadTerms) {
            if (useV8) {
                const response = yield (0, api_1.fetchTypeaheadResponseV8)(config, typeaheadTerms, productName, pmcUrl);
                return (0, utils_1.buildFormattedSuggestionsV8)(config, response, typeaheadTerms);
            }
            else {
                const response = yield (0, api_1.fetchTypeaheadResponse)(config, typeaheadTerms, productName, pmcUrl);
                return (0, utils_1.buildFormattedSuggestions)(config, response, pmcUrl);
            }
        }
        return undefined;
    }),
    [Services.FILL_IN_CONFIG_DEFAULTS]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { serverConfig, useV8, useLegacyConfig, pmcUrl } = context;
        // can't get this far without a config, OK to non-null assert here
        return (0, fillInConfigDefaults_1.fillInConfigDefaults)({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            serverConfig: serverConfig,
            useV8,
            useLegacyConfig,
            pmcUrl
        });
    }),
    [Services.INITIALIZE_LOGGING]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        const { config } = context;
        // the machine will not get this far without a valid context, so we can
        // non-null assert safely here
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, initializeLogging_1.initializeLogging)(config);
    })
};
//# sourceMappingURL=services.js.map